// src/modules/LiberacoesFinanceiras/index.jsx
import React, { useState, useEffect } from 'react';
import { MainContainer } from '../../components/template/MainContainer';
import DDAPaymentTable from './DDA/DDAPaymentTable';
import PixPaymentTable from './PIX/PixPaymentTable';
import Preloader from '../../components/template/Preloader';
import { fetchPayments as fetchDDAPayments } from './services/ddaPaymentService';
import { fetchPayments as fetchPixPayments } from './services/pixPaymentService';
import './index.css';

export default () => {
  const [paymentType, setPaymentType] = useState(null); // 'DDA' or 'PIX'
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!paymentType) return;

    const loadPayments = async () => {
      try {
        setLoading(true);
        const fetchFunction = paymentType === 'DDA' ? fetchDDAPayments : fetchPixPayments;
        const data = await fetchFunction();
        setPayments(data);
        setError(null);
      } catch (err) {
        setError('Error loading payments.');
        console.error('Error loading payments:', err);
        window.showAlert('danger', 'Error loading payments. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    loadPayments();
  }, [paymentType]);

  const handlePaymentsProcessed = () => {
    // Reload payments after processing
    setLoading(true);
    const fetchFunction = paymentType === 'DDA' ? fetchDDAPayments : fetchPixPayments;
    fetchFunction()
      .then(data => {
        setPayments(data);
        setError(null);
      })
      .catch(err => {
        setError('Error reloading payments.');
        console.error('Error reloading payments:', err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSelectPaymentType = (type) => {
    setPaymentType(type);
    setPayments([]);
    setError(null);
  };

  const handleBack = () => {
    setPaymentType(null);
    setPayments([]);
    setError(null);
  };

  // Show type selection screen
  if (!paymentType) {
    return (
      <MainContainer headerData={{ title: `Liberações Financeiras`, subtitle: `Selecione o tipo de pagamento` }}>
        <div className="container p-4">
          <div className="row">
            <div className="col-md-6 mb-3 d-flex">
              <button
                onClick={() => handleSelectPaymentType('DDA')}
                className="btn shadow-sm flex-fill themeTextColorPrimary fw-bold custom-font-size btn-click-effect"
              >
                DDA
              </button>
            </div>
            <div className="col-md-6 mb-3 d-flex">
              <button
                onClick={() => handleSelectPaymentType('PIX')}
                className="btn shadow-sm flex-fill themeTextColorPrimary fw-bold custom-font-size btn-click-effect"
              >
                PIX
              </button>
            </div>
          </div>
        </div>
      </MainContainer>
    );
  }

  if (loading) return <Preloader />;

  const subtitle = paymentType === 'DDA' ? 'Autorização de Pagamento DDA' : 'Autorização de Pagamento PIX';
  const PaymentTableComponent = paymentType === 'DDA' ? DDAPaymentTable : PixPaymentTable;

  if (error) {
    return (
      <MainContainer headerData={{ title: `Liberações Financeiras`, subtitle }}>
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
        <button className="btn btn-primary me-2" onClick={() => window.location.reload()}>
          Retry
        </button>
        <button className="btn btn-secondary" onClick={handleBack}>
          Voltar
        </button>
      </MainContainer>
    );
  }

  return (
    <MainContainer headerData={{ title: `Liberações Financeiras`, subtitle }}>
      {/* <div className="mb-3">
        <button className="btn btn-secondary btn-sm" onClick={handleBack}>
          ← Voltar
        </button>
      </div> */}
      <PaymentTableComponent payments={payments} onPaymentsProcessed={handlePaymentsProcessed} />
    </MainContainer>
  );
};
